import { CardItem } from '@/components/Card/Card';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconWeight from '@/icons/Weight.svg';
import { ArticleWithRelations } from '@/models/shipment';
import { formatWeight } from '@/utils/number';

const ArticleWeightCell = ({
  article,
  showIcon,
}: {
  article: ArticleWithRelations;
  showIcon?: boolean;
}) => {
  return (
    <Stack row gap="0.5rem" alignItems="center">
      {showIcon && <IconWeight style={{ fontSize: '1.25rem' }} />}
      <Paragraph weight="medium">{formatWeight(article.weight)}</Paragraph>
    </Stack>
  );
};

export default ArticleWeightCell;

export const ArticleWeightCardItem = ({ article }: { article: ArticleWithRelations }) => {
  return (
    <CardItem>
      <IconWeight style={{ fontSize: '1rem' }} />
      <span>{formatWeight(article.weight)}</span>
    </CardItem>
  );
};
